<template>
  <div
    :class="
      headerProps.layout === 'portal'
        ? 'header fixit-no__header'
        : 'fixit-no__header'
    "
  >
    <v-menu
      transition="slide-y-transition"
      content-class="fixit-no__mobile-menu"
      attach="#fixit-no__header"
      :rounded="false"
      offset-y
      :close-on-content-click="false"
      :close-on-click="false"
      :value="fixitMenuValue && isMounted && !$vuetify.breakpoint.mdAndUp"
      elevation="0"
    >
      <template v-slot:activator="{}">
        <the-app-bar
          :useOldNavigation="useOldNavigation"
          :header-props="headerProps"
          :active-user="user"
          :fixit-login-dialog="fixitLoginDialog"
          @setLogin="setLogin"
          :user-menu="userMenu"
          @setUserMenu="setUserMenu"
          :fixit-menu-value="fixitMenuValue"
          @setMenu="setMenu"
          :new-releases="newRelease"
          @logout="logout"
          @close-profile="showProfileDialog = false"
          :style="showHeader ? 'visibility: initial' : 'visibility: hidden'"
        >
          <template v-slot:logo>
            <slot name="logo"></slot>
          </template>
          <template v-slot:shopping-cart>
            <slot name="shopping-cart"></slot>
          </template>
        </the-app-bar>
      </template>
      <items
        :headerProps="headerProps"
        :items="headerProps.items.filter((i) => i.Visible)"
        @navigationAction="navigationAction"
        @closeMenu="fixitMenuValue = false"
      ></items>
    </v-menu>
    <login-dialog
      v-if="!user.onlineSluttKundeId"
      id="login-button"
      ref="loginDialog"
      :salons="headerProps.sites"
      :use-axios="useAxios"
      :oauthUrl="headerProps.oauthUrl"
      :use-fixit-oauth-login="headerProps.useFixitOauthLogin"
      :value="fixitLoginDialog"
      :apiUrl="headerProps.apiUrl"
      :user="user"
      :allowClickOutside="loginDialogClickOutside"
      @close-click="(val) => (fixitLoginDialog = val)"
      @click="login"
      @setUser="setUser"
      @notify="sendNotification"
      @membershipLogin="membershipLogin"
      :isProfile="headerProps.isProfile"
      :layout="headerProps.layout"
    >
    </login-dialog>
    <the-profile
      v-if="showProfileDialog && headerProps.layout == 'chain'"
      :layout="headerProps.layout"
      :isProfile="headerProps.isProfile"
      :use-axios="useAxios"
      :show="showProfileDialog"
      :user="user"
      @close-profile="showProfileDialog = false"
      @notify="sendNotification"
      @logout="logout"
      @updateUser="(user) => $emit('updateUser', user)"
      @update-employees="$emit('update-employees')"
      @update-treatments="$emit('update-treatments')"
    >
    </the-profile>
  </div>
</template>
<script>
import { User, Header } from "./models";
import { LoginDialog, TheAppBar, Items, TheProfile } from "./components";
import { createPrimaryOpacityVariables } from "./utils/opacity-colors";
import AppSvc from "./services/app-svc";
import { ProfileEventbus } from "./services/profile-svc";
import { AppEventbus } from "./services/app-svc";
import { GiftCardEventBus } from "./services/gift-card-svc";
let service = null;

export default {
  props: {
    /**
     * Options for integrated FixitNoHeader component
     *
     * required :
     *  @param {apiUrl} apiUrl url endpoint for login
     *
     * optional :
     *  @param {headerColors} headerColors  default ["#BFE5E8", "#EFDDD1"] ;
     *  @param {height} height  default 70 ;
     *  @param {elevation} elevation  default 3 ;
     *  @param {items} items  default [] ;
     *  @param {layout} layout  default 'chain' ;
     *  @param {atTop} atTop  default false ;
     * @see TheFixitNoHeader
     */
    headerProps: {
      type: [Header, Object],
      default: function () {
        return new Header();
      },
    },
    loginDialogClickOutside: {
      type: Boolean,
      required: false,
      default: true
    },
    /**
     * Currently logged in user or empty object
     * @see User
     */
    activeUser: {
      type: [User, Object],
      required: true,
    },
    /**
     * Boolean representing if the component should use global Vue app axios instance.
     * Requires the global Vue app axios instance to be set to $axios so it's accessible with this.$axios for the component to use.
     */
    useAxios: {
      type: Boolean,
      default: function () {
        return false;
      },
    },

    newRelease: {
      type: Boolean,
      default: false,
    },

    supportMembership: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    useOldNavigation: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  name: "TheFixitNoHeader",
  components: {
    LoginDialog,
    TheAppBar,
    Items,
    TheProfile,
  },
  data: () => ({
    fixitMenuValue: false,
    fixitLoginDialog: false,
    userMenu: false,
    isMounted: false,
    showProfileDialog: false,
    profilePage: "",
  }),
  computed: {
    activeTab() {
      // fixes slider position in case tabs weren't rendered
      if (this.$refs.tabs) this.$refs.tabs.callSlider();
      return this.headerProps.items.findIndex(
        (x) => x.Link === this.$route?.path
      );
    },
    home() {
      return this.$route?.path === "/";
    },
    user: {
      get() {
        return new User(this.activeUser);
      },
      set(user) {
        this.fixitLoginDialog = false;
        this.$emit("setUser", new User(user));
        if (this.$route.query && this.$route.query.returnUrl) {
          this.returnUrl = this.$route.query.returnUrl;
          if (this.$route.hash != "") {
            this.returnUrl += this.$route.hash;
          }
          localStorage.setItem("returnUrl", this.returnUrl);
        }
      },
    },
    showHeader() {
      return (
        (this.headerProps.isProfile && this.user.onlineSluttKundeId != 0) ||
        !this.headerProps.isProfile
      );
    },
  },
  methods: {
    navigationAction(nav) {
      if (this.fixitMenuValue) {
        this.fixitMenuValue = false;
      }
      if (nav.Dialog) {
        this[nav.DialogVariable] = true;
      } else if (nav.isInternal) {
        this.$router.push(nav.Link);
      } else if (nav.Link && nav.OpenInNewWindow) {
        window.open(nav.Link);
      } else if (nav.Caption == "Nettbutikk") {
        window.open(
          `${process.env.VUE_APP_FIXIT_NO_URL || this.$config.PORTAL_URL}${
            nav.Link
          }`,
          `${this.$config.PORTAL_URL ? "_blank" : "_self"}`
        );
      } else if (nav.Link.includes("/bedrift")) {
        window.open(`${process.env.VUE_APP_FIXIT_NO_URL}${nav.Link}`, "_self");
      } else if (nav.Caption == "Kjøp gavekort") {
        window.open(`${process.env.VUE_APP_FIXIT_NO_URL}${nav.Link}`, "_self");
      } else {
        this.$router.push(nav.Link);
      }
    },
    openDialog() {
      this.fixitLoginDialog = !this.fixitLoginDialog;
    },
    membershipLogin() {
      if (this.supportMembership) {
        this.$emit("loginWithJwt");
      }
    },
    async login(props) {
      this.loggingIn = true;
      let response = await service.Login(this.headerProps.apiUrl, {
        username: props.mobile,
        password: props.password,
      });

      if (
        (response != null || response != undefined) &&
        response.data.responseCode === 200
      ) {
        this.user = response.data.fixitNoUser;
        this.$axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${response.data.jwtToken}`;
        this.membershipLogin();
        this.$refs.loginDialog.reset(); //Reset the login inputs after user has logged in
        this.$emit("notify", {
          visible: true,
          duration: 3000,
          state: "info",
          message: "Du er logget inn!",
        });
      } else {
        this.$emit("notify", {
          visible: true,
          duration: 3000,
          state: "error",
          message: "Feil brukernavn eller passord. Prøv igjen!",
        });
      }
      this.loggingIn = false;
    },
    setUser(user) {
      this.user = user;
      if (user && user.onlineSluttKundeId) {
        this.membershipLogin();
        if (localStorage.getItem('isLogin')) {
          localStorage.removeItem('isLogin')
        }
        // if (this.headerProps.isProfile && this.headerProps.layout == "portal") {
        //   if(this.$router.query != null) this.$router.replace({query: null})
        // }
      } else {
        if (this.headerProps.isProfile && this.user.onlineSluttKundeId == 0 && this.headerProps.layout == "portal") {
          // this.$router.replace({query: { login: 'true'}})
          localStorage.setItem("isLogin", true);
        }
      }
    },
    sendNotification(snackbar) {
      this.$emit("notify", snackbar);
    },
    setLogin(value) {
      this.fixitLoginDialog = value;
    },
    setUserMenu(value) {
      this.userMenu = value;
    },
    setMenu(value) {
      this.fixitMenuValue = value;
    },
    openProfile() {
      this.showProfileDialog = true;
      this.setUserMenu(false);
    },
    async logout() {
      if (await service.Logout(this.headerProps.apiUrl)) {
        await service.HomepageLogout();
        this.setUserMenu(false);
        this.setUser(null);
        this.showProfileDialog = false;
        this.$emit("notify", {
          visible: true,
          duration: 3000,
          state: "info",
          message: "Du har logget ut!",
        });
      }
    },
  },
  watch: {
    $route(to) {
      if (to.query.title != null && this.user.onlineSluttKundeId != 0)
        this.openProfile();
      else {
        this.showProfileDialog = false;
      }
    },
  },
  async created() {
    service = await AppSvc(this.useAxios ? this.$axios : null);
    //Eventbuses used to emit snackbar events to parent application
    AppEventbus.$on("snackbar", (data) => {
      this.$emit("notify", data);
    });
    ProfileEventbus.$on("snackbar", (data) => {
      this.$emit("notify", data);
    });
    GiftCardEventBus.$on("snackbar", (data) => {
      this.$emit("notify", data);
    });
    var user = await service.getCurrentUser(this.headerProps.apiUrl);
    this.setUser(user);
    if (this.$route.query.title && this.user.onlineSluttKundeId != 0) {
      this.openProfile();
    }
    //Prompt login dialog if the user is on profile page while not logged in
    if (
      (this.headerProps.isProfile &&
        this.headerProps.layout == "portal" &&
        !this.user.onlineSluttKundeId) ||
      (this.$route.query.title && this.user.onlineSluttKundeId == 0)
    ) {
      this.setLogin(true);
    }
  },
  beforeDestroy() {
    AppEventbus.$off("snackbar");
    ProfileEventbus.$off("snackbar");
    GiftCardEventBus.$off("snackbar");
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
@import "./assets/styles/component.scss";

// Only for portal layout
.header {
  .toolbar {
    transition: background-color 250ms, height 250ms;

    .v-toolbar__content {
      transition: height 250ms;
      margin: 0 auto;
      padding: 0;
    }
  }
}
</style>
